/* eslint-disable max-len */
import { SvgProps } from './types'

export const FaceReaderAppIcon = ({ color, className, ...rest }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M27.9058 28.7517V36.8228C27.9058 37.7184 27.1731 38.5029 26.2776 38.5029H9.62829C8.73273 38.5029 8 37.7184 8 36.8228V4.13492C8 3.23566 8.73273 2.50293 9.62829 2.50293H26.2776C27.1731 2.50293 27.9058 3.23566 27.9058 4.13122V6.8216"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M16.5967 34.8726H19.3056"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M27.1436 26.2538H32.0136V21.3875" stroke={drawColor} strokeWidth="2" strokeMiterlimit="10" />
      <path d="M15.1865 14.2968V9.43048H20.0529" stroke={drawColor} strokeWidth="2" strokeMiterlimit="10" />
      <path d="M32.0136 14.2969V9.43054H27.1436" stroke={drawColor} strokeWidth="2" strokeMiterlimit="10" />
      <path d="M15.1865 21.3875V26.2538H20.0529" stroke={drawColor} strokeWidth="2" strokeMiterlimit="10" />
      <path
        d="M18.6396 23.186V21.9019C18.6396 19.9775 20.0311 19.2633 21.8259 19.2633H25.2157C27.0105 19.2633 28.5574 19.9775 28.5574 21.9019V23.186"
        stroke={drawColor}
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M26.0969 15.9697C26.0969 17.3611 24.9756 18.5009 23.6026 18.5009C22.2297 18.5009 21.1084 17.3611 21.1084 15.9697V15.0297C21.1084 13.6383 22.2334 12.4985 23.6026 12.4985C24.9719 12.4985 26.0969 13.6383 26.0969 15.0297V15.9697Z"
        stroke={drawColor}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
